import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { ff } from '@atlassian/jira-feature-flagging';
import { FormattedMessage, type MessageDescriptor } from '@atlassian/jira-intl';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

type Props = {
	letter: string;
	message?: MessageDescriptor;
};

const KeyboardShortcutTooltip = ({ letter, message }: Props) =>
	ff('plans-update-review-changes-to-unsaved-changes_sbz4w') ? (
		<Box xcss={tooltipContainerStyles}>
			{message ? (
				<Box xcss={textContainerStyles}>
					<FormattedMessage {...message} />
				</Box>
			) : null}
			<Box xcss={shortcutContainerStyles}>{letter}</Box>
		</Box>
	) : (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.tooltipContainer}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.textContainer}>
				<FormattedMessage {...message} />
			</div>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.shortcutContainer}>{letter}</div>
		</div>
	);

const tooltipContainerStyles = xcss({
	display: 'flex',
	paddingTop: 'space.025',
	paddingBottom: 'space.025',
	paddingLeft: '0',
	paddingRight: '0',
});

const shortcutContainerStyles = xcss({
	backgroundColor: 'color.background.neutral',
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: 'color.border.inverse',
	borderRadius: '2px',
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: 'space.050',
	paddingRight: 'space.050',
	marginTop: 'space.025',
	marginBottom: 'space.025',
	marginRight: '0',
	marginLeft: '0',
});

const textContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	marginRight: 'space.050',
});

export default KeyboardShortcutTooltip;
